/**
 * 請求月 (`2026-09`) を人が読む形 (`2026年9月`) にする (#1689)。
 *
 * **1 か所に置く。** バナー・申込み画面・催告メールが同じ請求を指すのに、
 * 実際に片方だけ日本語化して `2026-09分` と `2026年9月分` が並んだ。
 * backend 側は `services/email_notify.py` の `_jp_month` が同じ形を出す。
 */
export function formatBillingMonth(month: string | null | undefined): string {
  if (!month) return ''
  const [year, m] = month.split('-')
  return m ? `${year}年${Number(m)}月` : month
}
